import { render, staticRenderFns } from "./Digital.vue?vue&type=template&id=7b8d61e6"
import script from "./Digital.vue?vue&type=script&lang=ts"
export * from "./Digital.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports